import { get } from "./_utils";

export const polling = (pid, params = {}) => {
  return get("/polling", { pid, ...params });
};
